import './dictionary.less'

import {m, wrap} from '@codeurs/front'
import {Component, Fragment} from 'react'
import {PageData} from 'types'
import {style} from 'util/style'
import {Layout} from 'views/layout'
import {Newsletter} from 'views/partials/newsletter'
import {Theme} from 'views/theme'
import {HeaderPortal} from '../partials/header'
import {Hero} from '../partials/hero'

type Term = {
  letter: string
  title: string
  text: string
}

const styles = style('dictionary')

const LETTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('')

@wrap(Layout)
export class Dictionary extends Component<{
  data: PageData & {
    terms: Array<Term>
  }
}> {
  render() {
    const chosenLetter = location.hash.substring(1) || 'A'
    const {title, terms, hero, newsletter, language} = this.props.data
    const usedLetters = new Set(terms.map(term => term.letter))
    return (
      <Fragment>
        <div class={styles}>
          <Theme.Container>
            <HeaderPortal>
              <Hero hero={!!(hero && hero.image)} small={false} wide={true}>
                <Theme.H1>{title}</Theme.H1>
              </Hero>
            </HeaderPortal>
            <div className={styles('letters-container')}>
              <div className={styles('letters')}>
                <div className={styles('letters-row')}>
                  {LETTERS.map(L => (
                    <div
                      className={styles('letters-item')
                        .mod({unavailable: !usedLetters.has(L)})
                        .is({active: chosenLetter === L})}
                      onClick={() => {
                        location.hash = L
                      }}
                    >
                      {L}
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className={styles('terms')}>
              {terms
                .filter(term => term.letter === chosenLetter)
                .sort()
                .map(term => (
                  <div className={styles('term')}>
                    <Theme.H3 className={styles('term-title')}>
                      {term.title}
                    </Theme.H3>
                    <p className={styles('term-text')}>{term.text}</p>
                  </div>
                ))}
            </div>
          </Theme.Container>
        </div>
        <Newsletter {...newsletter} language={language} />
      </Fragment>
    )
  }
}
